<template>
    <form class="naw" @submit.prevent="onSubmit">
        <div class="grid-container">

            <div class="rs col-12">
                <v-gender-input v-model="naw.gender" v-validate="'required'"></v-gender-input>
            </div>

            <div class="rs col-12 m-col-8">
                <label for="firstname">Voornaam*</label>
                <input id="firstname" name="firstname" v-model="naw.firstname" :class="{ 'error': errors.has('firstname'), 'correct': fields.firstname && fields.firstname.valid && fields.firstname.validated }" v-validate="'required|min:2'" type="text" tabindex="1" autocomplete="given-name" />
                <span class="tooltip">{{ errors.first( 'firstname' ) }}</span>
            </div>
            <div class="rs col-12 m-col-4">
                <label for="infixname">Tussenvoegsel</label>
                <input id="infixname" name="infixname" v-model="naw.infixname" type="text" tabindex="2" autocomplete="additional-name" />
                <span class="tooltip"></span>
            </div>
            <div class="rs col-12">
                <div class="form-input">
                    <label for="surname">Achternaam*</label>
                    <input id="surname" name="surname" v-model="naw.surname" :class="{ 'error': errors.has('surname'), 'correct': fields.surname && fields.surname.valid && fields.surname.validated }" v-validate="'required|min:2'" type="text" tabindex="3" autocomplete="family-name" />
                    <span class="tooltip">{{ errors.first( 'surname' ) }}</span>
                </div>
            </div>

            <div class="rs col-12">
                <span class="tooltip birthdayerror" v-if="birthdayError === true">Je moet minstens 18 jaar zijn om mee te kunnen spelen</span>
            </div>

            <div class="rs col-4">
                <label for="day_of_birth">Geboortedatum*</label>
                <select name="day_of_birth" v-model="naw.day_of_birth" :class="{ 'error': errors.has('date_of_birth'), 'correct': fields.date_of_birth && fields.date_of_birth.valid && fields.date_of_birth.validated }"  tabindex="4">
                    <option value="" disabled>dag</option>
                    <option v-for="i in 31" :selected="i === naw.day_of_birth">{{ i }}</option>
                </select>
                <span class="tooltip">{{ errors.first( 'surname' ) }}</span>

            </div>
            <div class="rs col-4">
                <div class="form-input">
                    <label for="month_of_birth">&nbsp;</label>
                    <select name="month_of_birth" v-model="naw.month_of_birth" :class="{ 'error': errors.has('date_of_birth'), 'correct': fields.date_of_birth && fields.date_of_birth.valid && fields.date_of_birth.validated }"  tabindex="5">
                        <option value="" disabled>maand</option>
                        <option v-for="i in 12" :selected="i === naw.month_of_birth" :value="i">{{ months[i-1] }}</option>
                    </select>
                </div>
            </div>
            <div class="rs col-4">
                <div class="form-input">
                    <label for="year_of_birth">&nbsp;</label>
                    <select name="year_of_birth" v-model="naw.year_of_birth" :class="{ 'error': errors.has('date_of_birth'), 'correct': fields.date_of_birth && fields.date_of_birth.valid && fields.date_of_birth.validated }"  tabindex="6">
                        <option value="" disabled>jaar</option>
                        <option v-for="i in 100" :selected="( 2002 - i ) === naw.year_of_birth">{{ ( 2002 - i ) }}</option>
                    </select>
                </div>
            </div>

            <div class="rs col-4">
                <label for="zipcode">Postcode*</label>
                <input id="zipcode" name="zipcode" v-model="naw.zipcode" maxlength="7" :class="{ 'error': errors.has('zipcode'), 'correct': fields.zipcode && fields.zipcode.valid && fields.zipcode.validated }" v-validate="{ required: true, regex: /^[0-9]{4} {0,1}[A-Za-z]{2}$/ }" type="text" tabindex="7" autocomplete="postal-code" />
                <span class="tooltip">{{ errors.first( 'zipcode' ) }}</span>
            </div>
            <div class="col-4">
                <label for="house_num">Huisnr*</label>
                <input id="house_num" name="house_num" v-model="naw.house_num" :class="{ 'error': errors.has('house_num'), 'correct': fields.house_num && fields.house_num.valid && fields.house_num.validated }" v-validate="'required|min:1|min_value:1'" type="number" min="1" tabindex="8" />
                <span class="tooltip">{{ errors.first( 'house_num' ) }}</span>
            </div>
            <div class="col-4">
                <label for="house_num_add">Toev.</label>
                <input id="house_num_add" name="house_num_add" v-model="naw.house_num_add" class="" type="text" tabindex="9" />
            </div>

            <div class="rs col-12">
                <label for="telephone">Telefoonnummer</label>
                <!-- <p class="small">Vul uw telefoonnummer in en ontvang eenmalig een telefonisch aanbod van Staatsloterij om automatisch mee te spelen</p> -->
                <input id="telephone" name="telephone" autocomplete="tel-national" v-model="naw.telephone" :class="{ 'error': errors.has('telephone') }" v-validate="{ required: false, regex: /^((\+|00(\s|\s?\-\s?)?)31(\s|\s?\-\s?)?(\(0\)[\-\s]?)?|0)[1-9]((\s|\s?\-\s?)?[0-9])((\s|\s?-\s?)?[0-9])((\s|\s?-\s?)?[0-9])\s?[0-9]\s?[0-9]\s?[0-9]\s?[0-9]\s?[0-9]$/ }" type="tel" tabindex="10" />
                <span class="tooltip">{{ errors.first('telephone') }}</span>
            </div>

            <div class="rs col-12">
                <p class="small">Vul je telefoonnummer in en ontvang eenmalig een telefonisch aanbod van de Staatsloterij of Lotto om automatisch mee te spelen.</p>
            </div>

            <div class="rs col-12">
                <label for="emailaddress">E-mailadres*</label>
                <input id="emailaddress" name="emailaddress" v-model="naw.emailaddress" :class="{ 'error': errors.has('emailaddress') || emailerror, 'correct': !emailerror && fields.emailaddress && fields.emailaddress.valid && fields.emailaddress.validated }" v-validate="'required|email'" type="email" tabindex="11" autocomplete='email' />
                <span class="tooltip">{{ errors.first('emailaddress') }}</span>
                <span class="tooltip" v-if="emailerror">{{ emailerror }}</span>
            </div>

            <div class="rs col-12">
                <div class="selectable" v-bind:class="{ 'is-checked': naw.kit }">
                    <span class="indicator"></span>
                    <input type="checkbox" id="kit-checkbox" name="kit-checkbox" v-model="naw.kit" ref="kit" tabindex="12" />
                    <label class="text-label" for="kit-checkbox">
                        <!-- Ik wil per e-mail alleen op mijn interesses afgestemde berichten en aanbiedingen van de (toekomstige) kansspelen van de Nederlandse Loterij ontvangen. -->
                        Ja, Ik wil per e-mail berichten en aanbiedingen van de (toekomstige) kansspelen van de Nederlandse Loterij ontvangen.
                    </label>
                </div>
            </div>

            <!-- <div class="rs col-12">
                <div class="selectable" v-bind:class="{ 'is-checked': naw.age, 'error': errors.has('age-checkbox') }">
                    <span class="indicator"></span>
                    <input type="checkbox" id="age-checkbox" name="age-checkbox" v-model="naw.age" v-validate="'required'" data-vv-validate-on="input" ref="age" />
                    <label class="text-label" for="age-checkbox">
                        Ik ben 18+ en ga akkoord met de <a href="/static/pdf/actievoorwaarden.pdf" target="_blank">actievoorwaarden</a>.
                    </label>
                </div>
                <span class="tooltip">Je moet minstens 18+ zijn om aan deze actie mee te doen</span>
            </div> -->

            <!-- <div class="rs rm col-12">
                <label :class="{ 'recaptcha': true, 'error': recaptchaError }">
                    <div ref="recaptcha" class="g-recaptcha" data-sitekey="6Le4pnwUAAAAADEDrsn5BCifb5paqEwDjl-tRkxO"></div>
                </label>
                <span class="tooltip" v-if="recaptchaError">Recaptcha aanvinken is verplicht</span>
            </div> -->

            <div class="rs col-12">
                <p class="small extra-margin">Velden met een * zijn verplicht</p>
            </div>
        </div>

        <button class="stl" type="submit" v-bind:disabled="waitingForApi"><span>Verstuur je gegevens</span><v-spinner v-if="waitingForApi"></v-spinner></button>

        <p class="small centered">Door op verstuur te drukken ga je akkoord met <br/>de <a href="/static/pdf/actievoorwaarden.pdf" target="_blank">actievoorwaarden</a> en het <a href="https://www.nederlandseloterij.nl/privacy" target="_blank">Privacy Statement</a></p>
    </form>
</template>

<style lang="scss" scoped>
    span.birthdayerror{
        display:block;
    }
</style>

<script>
    // import Vue from 'vue';
    import Spinner from '@/app/components/Spinner';
    import { recaptcha } from '@/app/mixins';
    import GenderInput from '@/app/components/GenderInput';

    export default {
        components: {
            'v-spinner': Spinner,
            'v-gender-input': GenderInput
        },

        mixins: [ recaptcha ],

        data()
        {
            return {
                waitingForApi: false,
                birthdayError: false,
                emailerror: null,
                // recaptchaError: false,
                naw: {
                    gender: null,
                    firstname: '',
                    infixname: '',
                    surname: '',
                    zipcode: '',
                    house_num: '',
                    house_num_add: '',
                    emailaddress: '',
                    telephone: '',
                    date_of_birth: '',
                    day_of_birth: '',
                    month_of_birth: '',
                    year_of_birth: '',
                    kit: false
                    // age: false
                },
                months: [
                    'januari',
                    'februari',
                    'maart',
                    'april',
                    'mei',
                    'juni',
                    'juli',
                    'augustus',
                    'september',
                    'oktober',
                    'november',
                    'december'
                ]
            };
        },

        computed: {
            formattedDateOfBirth()
            {
                if( this.naw.day_of_birth === '' || this.naw.month_of_birth === '' || this.naw.year_of_birth === '' )
                {
                    return '';
                }
                return this.naw.year_of_birth + '-' + ( '0' + this.naw.month_of_birth ).slice( -2 ) + '-' + ( '0' + this.naw.day_of_birth ).slice( -2 );
            }
        },

        watch: {
            'naw.day_of_birth': function()
            {
                if( this.formattedDateOfBirth )
                {
                    this.naw.date_of_birth = this.formattedDateOfBirth;
                }
            },

            'naw.month_of_birth': function()
            {
                if( this.formattedDateOfBirth )
                {
                    this.naw.date_of_birth = this.formattedDateOfBirth;
                }
            },

            'naw.year_of_birth': function()
            {
                if( this.formattedDateOfBirth )
                {
                    this.naw.date_of_birth = this.formattedDateOfBirth;
                }
            },

            'naw.emailaddress': function()
            {
                if( this.emailerror )
                {
                    this.emailerror = null;
                }
            },

            'naw.gender': function( pVal )
            {
                // console.log( 'gender changed' );
                this.$validator.validate( 'gender' );
            }
        },

        mounted()
        {
            /* Vue.nextTick( () =>
            {
                window.grecaptcha.render(
                    this.$refs.recaptcha,
                    {
                        sitekey: '6Le4pnwUAAAAADEDrsn5BCifb5paqEwDjl-tRkxO',
                        theme: 'light'
                    }
                );
            }); */
        },

        methods: {
            async onSubmit( e )
            {
                this.birthdayError = false;

                if( this.formattedDateOfBirth )
                {
                    let today = new Date();
                    today.setYear( 2001 );
                    today.setHours( 0 );
                    today.setMinutes( 0 );
                    today.setSeconds( 0 );

                    let todayTime = today.getTime();

                    let birthday = new Date( this.formattedDateOfBirth );
                    birthday.setHours( 0 );
                    let birthdayTime = birthday.getTime();

                    if( birthdayTime < todayTime )
                    {
                        this.birthdayError = false;
                    }
                    else
                    {
                        this.birthdayError = true;
                    }
                }

                if( this.birthdayError === true )
                {
                    return;
                }

                await this.executeRecaptcha();

                this.waitingForApi = true;

                this.$validator.validateAll().then( result =>
                {
                    if( result )
                    {
                        // if( window.dingos.length === 0 )
                        // {
                        //     this.recaptchaError = true;
                        //     throw new Error( 'Captcha error' );
                        // }
                        // else
                        // {
                        //     this.recaptchaError = false;
                        // }

                        this.waitingForApi = true;
                        let entry = Object.assign({ 'g-recaptcha-response': window.recaptchaToken }, this.naw );

                        return this.$store.dispatch( 'saveEntry', entry );
                    }

                    throw new Error( 'invalid' );
                })
                .then( () =>
                {
                    this.waitingForApi = false;
                    // if( !this.recaptchaError )
                    // {
                    //     this.$router.replace({ path: '/bedankt' });
                    // }

                    this.$router.replace({ path: '/bedankt' });
                })
                .catch( error =>
                {
                    this.waitingForApi = false;

                    for( let item in error.errors )
                    {
                        if( item === 'emailaddress' )
                        {
                            this.emailerror = error.errors['emailaddress'][0];
                        }
                    }
                });
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/components/Form.vue